<template>
    <div>
        <template v-if="subscription_fee_configuration == true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Source Wise Subscription</h1>
            </div>
            <div class="global-main">
                <form id="transactionFeeForm" @submit.prevent="addSubscriptionFeeData">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Onboard Source<em class="required">*</em> </label>
                            <select v-model="form.onboard_source_id" data-live-search="true" name="onboard_source_id" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('onboard_source_id') }">
                                <option value="" selected>Select</option>
                                <option v-for="onboard in onboardsourceslist" v-bind:value="onboard.id" v-bind:key="onboard.id">{{ onboard.name }}</option>
                            </select>
                            <has-error :form="form" field="companyId"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Fee  <em class="required">*</em></label>
                            <input v-model="form.fee" type="text" name="fee" class="form-control" :class="{ 'is-invalid': form.errors.has('fee') }">
                        </div>
                        <div class="form-group">
                            <label> Status<em class="required">*</em> </label>
                            <select v-model="form.status" name="status" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                                <option value="" selected>Select Status</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">In-active</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/subscriptionFee?tab=source-wise" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="subscription_fee_configuration === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="subscription_fee_configuration === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    onboard_source_id: "",
                    chargesType:"SUBSCRIPTION",
                    fee: "",
                    status: "",
                }),
                onboardsourceslist: '',
                subscription_fee_configuration: null,
            };
        },
        methods: {
            addSubscriptionFeeData() {
                this.$Progress.start();
                this.form
                    .post("api/updateTransactionAndSubscriptionCharges")
                    .then((res) => {
                        if (res.status == 200) {
                            if (res.data.code == 200) {
                                this.resetForm();
                                this.$Progress.finish();
                                this.showToastBox("success", "Transaction Fee added successfully");
                                this.$router.push({ path: '/subscriptionFee', query: { tab: 'source-wise' } });
                            } else {
                                this.showToastBox("error", res.data.message);
                            }
                        } else {
                            this.$Progress.fail();
                            this.showAlertBox("error", "Some error in your form data");
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                        }
                    }).then(res => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        const errorMessages = Object.entries(err.response.data.errors)
                            .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                            .join('\n');
                        this.showAlertBox('error', `Validation errors:\n${errorMessages}`);
                    });
            },
            resetForm() {
                this.form.companyId = "";
                this.form.fee = "";
                this.form.status = "";
            },
            onBoardCompaniesList(){
                this.$Progress.start();
                axios.get('/api/listOnboardSources')
                    .then(res => {
                        if(res.status == 200){
                            this.onboardsourceslist = res.data.data;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some error in your form data');
                        }
                    }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                    .catch(err => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.showAlertBox('error','Some error in your form data');
                    });
            }
        },
        mounted() {
            this.$Progress.start();
            this.can("subscription_fee_configuration")
                .then((result) => {
                    this.subscription_fee_configuration = result.subscription_fee_configuration;
                })
                .then((result) => {
                    if (this.subscription_fee_configuration == true) {
                        this.onBoardCompaniesList();
                        this.$Progress.finish();
                    } else {
                        this.$Progress.finish();
                    }
                });
        },
    }
</script>
